import { render, staticRenderFns } from "./CommonTableComponent.vue?vue&type=template&id=31a7c2ad"
import script from "./CommonTableComponent.vue?vue&type=script&lang=js"
export * from "./CommonTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports